import React from 'react'

const LinkIcon = () => {
    return (

        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 9.808 9.808"
            fill="currentColor"
            aria-hidden="true"
            className='link-icon'
        >
            <path
                d="m7.0817 0c-0.68992 0.0043117-1.3784 0.27115-1.8996 0.79892l-0.7307 0.74207c-0.54961 0.51999 0.14962 1.1444 0.65009 0.65009l0.73484-0.74621c0.69602-0.70475 1.8036-0.71204 2.5084-0.01602 0.70475 0.69603 0.71205 1.8041 0.016021 2.5089l-1.6666 1.6867c-0.69602 0.70475-1.8036 0.71152-2.5084 0.015502-0.22058-0.21784-0.37276-0.47583-0.4563-0.74931-0.25829-0.71431-1.0044-0.0065828-0.81804 0.42995 0.13259 0.35563 0.34284 0.68849 0.62994 0.97203 1.0555 1.0425 2.763 1.0323 3.8055-0.023254l1.666-1.6872c1.0425-1.0555 1.0333-2.7645-0.022222-3.807-0.52777-0.52123-1.219-0.77946-1.9089-0.77515zm-2.742 2.7404c-0.68909 0.0042201-1.3763 0.27063-1.8976 0.7984l-1.6666 1.6872c-1.0425 1.0555-1.0333 2.7645 0.022221 3.807 1.0555 1.0425 2.7661 1.0318 3.8086-0.02377l0.73122-0.74207c0.54961-0.51999-0.14962-1.1444-0.65009-0.65009l-0.73484 0.74621c-0.69602 0.70475-1.8041 0.71153-2.5089 0.015502-0.70475-0.69603-0.71153-1.8036-0.015503-2.5084l1.666-1.6867c0.69603-0.70475 1.8036-0.71204 2.5084-0.01602 0.22058 0.21784 0.37276 0.47634 0.4563 0.74983 0.25829 0.71431 1.0044 0.0060166 0.81804-0.43046-0.13259-0.35563-0.34232-0.68849-0.62942-0.97203-0.52777-0.52123-1.2188-0.77885-1.9079-0.77463z"
            />
        </svg>
    )
}

export default LinkIcon
